import { Card, CardContent, Chip, Grid, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import AntSwitch from '../dailydose/AntSwitch';

const useStyles = makeStyles(() => ({
  cardContent: {
    marginRight: '10px',
    marginTop: '10px',
    marginBottom: '10px',
    border: 0,
    backgroundColor: '#F2F4F7',
  },
  scrollContent: {
    marginTop: '10px',
    width: '100%',
    maxHeight: (props) => props.scrollContentHeight || '400px',
    minHeight: '10vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  orCondition: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '15px',
    lineHeight: '20px',
  },
  chipOrCondition: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '13px',
    lineHeight: '13px',
  },
  andCondition: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '15px',
    lineHeight: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  chipStyle: {
    backgroundColor: '#F2F4F7',
    marginTop: '5px',
    marginBottom: '5px',
    marginRight: '3px',
    marginLeft: '3px',
  },
}));

export default function RulesDisplay({
  ruleDetails,
  showMandatory,
  handleMandatory,
  mandatoryRuleCoditions = {},
  scrollContentHeight,
}) {
  const classes = useStyles({ scrollContentHeight });

  const prepareRuleOutput = (condition) => {
    const output = [];
    for (let i = 0; i < condition.length; i += 1) {
      output.push(
        <Card variant="outlined">
          {condition[i].map((k, z) => (
            <>
              <Chip className={classes.chipStyle} label={k.name} />
              {z < condition[i].length - 1 ? <span className={classes.chipOrCondition}>OR</span> : null}
            </>
          ))}
        </Card>,
      );
    }
    return output;
  };

  return (
    <div className={classes.scrollContent}>
      {ruleDetails?.conditions?.length ? (
        ruleDetails.conditions.map(({ condition, id }, i) => (
          <>
            <Grid item md={12} key={id}>
              <Card className={classes.cardContent} raised={false} variant="outlined">
                <CardContent>
                  <Grid container justifyContent="flex-start" alignItems="center">
                    {prepareRuleOutput(condition).map((rC, j, arr) => (
                      <>
                        <Grid item xs={arr.length === 2 ? 5 : 10} style={{ marginTop: '4px', marginBottom: '4px' }}>
                          <Typography>{rC}</Typography>
                        </Grid>
                        {j < arr.length - 1 ? (
                          <Grid item xs={2} className={classes.andCondition}>
                            AND
                          </Grid>
                        ) : null}
                      </>
                    ))}
                  </Grid>
                </CardContent>
                {showMandatory && (
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    alignContent="flex-end"
                    style={{ paddingBottom: '10px', paddingRight: '10px', gap: '10px' }}
                  >
                    <Typography style={{ color: 'rgba(0, 0, 0, 0.4)', fontSize: '13px', fontWeight: '600' }}>
                      IS MANDATORY
                    </Typography>
                    <Grid item>
                      <AntSwitch
                        defaultChecked={mandatoryRuleCoditions[id]}
                        name={`rule_condition_${id}`}
                        onChange={(e) => handleMandatory(id, e.target.checked)}
                        style={{ cursor: 'pointer' }}
                      />
                    </Grid>
                  </Grid>
                )}
              </Card>
            </Grid>
            {i < ruleDetails.conditions.length - 1 ? (
              <Grid container justifyContent="center">
                <Grid item md={5}>
                  <hr />
                </Grid>
                <Grid item md={1} className={classes.orCondition}>
                  OR
                </Grid>
                <Grid item md={5}>
                  <hr />
                </Grid>
              </Grid>
            ) : null}
          </>
        ))
      ) : (
        <Grid item xs={12} style={{ textAlign: 'center', marginTop: '10px' }}>
          No Rule Conditions
        </Grid>
      )}
    </div>
  );
}
